import { gql } from "@apollo/client";

export const USER_POOL_GET_REDIRECT_URL = gql`
  query GetRedirectUrl($offerId: ID!) {
    getRedirectUrl(offerId: $offerId) {
      url
    }
  }
`;
